import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

interface UpdateOrderStatusParams {
	orderId: string
	newStatus: string
}

// TODO: Replace this mock with real API call when backend is ready
// Expected API endpoint: PUT /api/orders/{orderId}/status
// Expected payload: { status: string }
// Expected response: { success: boolean, order: Order }
const updateOrderStatusApi = async ({ orderId, newStatus }: UpdateOrderStatusParams): Promise<void> => {
	// Simulate network delay for realistic UX
	await new Promise(resolve => setTimeout(resolve, 300 + Math.random() * 200))
	
	// TODO: Replace with actual API call
	// const response = await fetch(`/api/orders/${orderId}/status`, {
	//   method: 'PUT',
	//   headers: { 'Content-Type': 'application/json' },
	//   body: JSON.stringify({ status: newStatus })
	// })
	// if (!response.ok) throw new Error('Failed to update order status')
	// return response.json()
	
	console.log(`[MOCK] Updating order ${orderId} to status: ${newStatus}`)
	
	// Mock always succeeds for now
	// The actual data update is handled by optimistic updates in the component
}

export const useUpdateOrderStatus = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: updateOrderStatusApi,
		onMutate: async ({ orderId, newStatus }) => {
			// Cancel any outgoing refetches for all orders queries
			await queryClient.cancelQueries({ queryKey: ['orders'] })

			// Get all orders queries from cache
			const ordersQueries = queryClient.getQueriesData({ queryKey: ['orders'] })

			// Update all orders queries in cache
			ordersQueries.forEach(([queryKey, data]) => {
				if (data && typeof data === 'object' && 'orders' in data) {
					const oldData = data as any
					
					const updatedOrders = oldData.orders.map((order: any) => {
						if (order.id === orderId) {
							return { ...order, stage: newStatus, updated_at: new Date().toISOString() }
						}
						return order
					})
					
					const result = {
						...oldData,
						orders: updatedOrders
					}
					
					queryClient.setQueryData(queryKey, result)
				}
			})

			// Return a context object with the snapshotted values
			return { previousQueries: ordersQueries }
		},
		onSuccess: () => {
			// Success toast is handled in the component
		},
		onError: (err, _variables, context) => {
			// If the mutation fails, use the context returned from onMutate to roll back
			if (context?.previousQueries) {
				context.previousQueries.forEach(([queryKey, data]) => {
					queryClient.setQueryData(queryKey, data)
				})
			}
			
			toast.error('Failed to update order status')
			console.error('Error updating order status:', err)
		},
	})
}
